import React from 'react'
import { Box, Card, CardContent, Grid, Typography } from '@mui/material'

const MobileOrderCard = ({ data, handleRowClick }) => {
  return (
    <Box sx={{ width: '100%', padding: 0.5 }}>
      {data?.map((row, index) => (
        <Card
          key={index}
          onClick={() => handleRowClick(row)}
          sx={{ marginBottom: 2, backgroundColor: 'var(--bg-paper)', borderRadius: 4, position: 'relative', cursor: 'pointer' }}
        >
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Grid container spacing={2} sx={{ marginTop: 1 }}>
                <Grid item xs={6}>
                  <Typography
                    fontSize={14}
                    fontFamily="poppins"
                    color="var(--text-tertiary)"
                    fontWeight={600}
                    textAlign="left"
                  >
                    Order Id
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontSize={14}
                    fontFamily="Poppins"
                    color={row.error ? '#ba090c' : 'var(--text-tertiary)'}
                    fontWeight={500}
                    noWrap
                    overflow="hidden"
                    textOverflow="ellipsis"
                    textAlign="left"
                  >
                    : {row?.order_id}
                  </Typography>
                </Grid>
                {/* Add other fields here similarly */}
              </Grid>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  )
}

export default MobileOrderCard
